import { forwardRef } from 'react';
import type { PropsWithoutRef } from 'react';

import { useI18n } from '@pega/cosmos-react-core';
import type { ForwardRefForwardPropsComponent } from '@pega/cosmos-react-core';

import Message from './Message';
import type { TypeIndicatorProps } from './Chat.types';

const TypeIndicator: ForwardRefForwardPropsComponent<TypeIndicatorProps> = forwardRef(
  function TypeIndicator(
    {
      avatarInfo,
      message,
      senderId,
      senderType,
      agentVariant,
      ...restProps
    }: PropsWithoutRef<TypeIndicatorProps>,
    ref: TypeIndicatorProps['ref']
  ) {
    const t = useI18n();

    const ariaLabel = t('is_typing', [avatarInfo.name, message || '']);
    return (
      <Message
        {...restProps}
        senderType={senderType}
        senderId={senderId}
        direction='in'
        avatarInfo={avatarInfo}
        agentVariant={agentVariant}
        typing
        ref={ref}
        message={message}
        aria-label={ariaLabel}
      />
    );
  }
);

export default TypeIndicator;
